<template>
  <template-list
    :model="$ingredientGroup"
    :items="list"
    title="Модификаторы"
    titleClass="text-h5 font-weight-bold"
    titleStyle="color: black"
    :show-create-button="false"
  >
    <template v-slot:actions>
      <search
        :rounded="false"
        always
        v-model="search"
      ></search>
    </template>
    <template v-slot="{ object, to }">
      <v-col>
        <v-row
          no-gutters
          align="center"
        >
          <v-row
            no-gutters
            align="center"
            class="text-h6 font-weight-bold text-black"
            style="color: black"
          >
            <div class="mr-2">
              {{ object.vendor_name || 'Отсутствует' }}
            </div>
            <div
              class="text-caption mr-2"
              v-if="object.name"
            >
              ({{ object.name }})
            </div>
            <div class="mr-2 text-caption">
              Количество модификаторов: {{ object.ingredients.length }}
            </div>
          </v-row>
        </v-row>
        <v-col
          class="pa-0"
          v-for="(ingredient, index) in filterItems(object.ingredients)"
          :key="index"
          :class="{ 'mt-4': index }"
        >
          <IngredientCell
            class="mt-2 mb-2"
            :item="ingredient"
            @click="select(ingredient)"
          />
        </v-col>
      </v-col>
    </template>
  </template-list>
</template>

<script>
  import search from 'air-vue-model/search'
  import Search from '@/components/template/Search'
  import DiscountSystemInformation from '@/admin/views/discountSystems/DiscountSystemInformation.vue'
  import IngredientCell from './IngredientCell.vue'

  export default {
    name: 'SelectableIngredientGroupList',
    components: {
      DiscountSystemInformation,
      Search,
      IngredientCell
    },
    props: {
      selectedIngredients: []
    },
    data: () => ({
      search: null
    }),
    methods: {
      filterItems(items) {
        return search(this.search, items, val => val.vendor_name)
      },
      select(item) {
        this.$emit('select', item)
      }
    },
    computed: {
      list() {
        const excludedProductsIdSet = new Set(this.selectedIngredients)
        const filteredGroupIngredients = this.$ingredientGroup.list
          .map(group => ({
            ...group,
            ingredients: group.ingredients.filter(res => !excludedProductsIdSet.has(res.id))
          }))
          .filter(group => group.ingredients.length > 0)

        if (!this.search) return filteredGroupIngredients
        return filteredGroupIngredients.filter(v => {
          return this.filterItems(v).length > 0
        })
      }
    }
    // computed: {
    //   groups() {
    //     const excludedProductsIdSet = new Set(this.selectedProducts)
    //     return this.$productGroup.list
    //       .filter(e => e.id !== this.$productGroup.item.id)
    //       .map(group => ({
    //         ...group,
    //         products: group.products.filter(p => !excludedProductsIdSet.has(p.id))
    //       }))
    //       .filter(group => group.products.length > 0)
    //   }
    // },
  }
</script>
